var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#545454",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.98108C20.0102 15.4908 15.5169 19.9961 10.0072 19.9999C7.62761 20.0016 5.44181 19.1721 3.72411 17.7858C3.27746 17.4253 3.24407 16.7559 3.64996 16.35L4.10427 15.8957C4.45141 15.5486 5.0056 15.5106 5.3902 15.8157C6.65572 16.8199 8.25729 17.4193 9.99999 17.4193C14.101 17.4193 17.4193 14.1004 17.4193 9.99999C17.4193 5.89899 14.1004 2.58064 9.99999 2.58064C8.03169 2.58064 6.24399 3.34552 4.91661 4.59403L6.96314 6.64056C7.36959 7.04701 7.08173 7.74193 6.50697 7.74193H0.645161C0.28883 7.74193 0 7.4531 0 7.09677V1.23496C0 0.660201 0.694919 0.372338 1.10137 0.778749L3.09217 2.76955C4.88746 1.05387 7.32064 0 9.99999 0C15.5165 0 19.9898 4.46693 20 9.98108ZM12.7052 13.1579L13.1012 12.6486C13.4294 12.2267 13.3534 11.6187 12.9315 11.2906L11.2903 10.0141V5.80645C11.2903 5.27197 10.857 4.83871 10.3226 4.83871H9.67741C9.14294 4.83871 8.70967 5.27197 8.70967 5.80645V11.2762L11.3471 13.3276C11.769 13.6557 12.377 13.5797 12.7052 13.1579Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistory);
export default __webpack_public_path__ + "static/media/order-history.345f293fe1bf49e5375a101f893cd6a4.svg";
export { ForwardRef as ReactComponent };